import styled from '@emotion/styled'
import { CartTitle } from '../Cart'
import { CartType } from '../Cart/Cart'
import { LineBreak } from '../Shop/commonStyles'
import { StyledHTMLElement } from 'shop/theme/types'

interface Props {
  isModal: boolean
}

const ShopCartHeader = ({ isModal }: Props) => {
  return (
    <ModalHeaderContainer isModal={isModal}>
      <CartTitleContainer isModal={isModal}>
        <CartTitle type={CartType.Shop} />
      </CartTitleContainer>
      <LineBreakContainer>
        <LineBreak height={'2px'} />
      </LineBreakContainer>
    </ModalHeaderContainer>
  )
}

const CartTitleContainer = styled.div<StyledHTMLElement & { isModal: boolean }>(
  ({ isModal }) => ({
    marginBottom: !isModal ? '16px' : '21px'
  })
)

const LineBreakContainer = styled.div<StyledHTMLElement & { margin?: string }>(
  ({ margin = '0 -16px 0px' }) => ({
    margin: margin,
    boxShadow: '0px 5px 12px 1px rgba(0, 0, 0, 0.05)'
  })
)

const ModalHeaderContainer = styled.div<
  StyledHTMLElement & { isModal: boolean }
>(({ isModal }) => ({
  backgroundColor: 'white',
  position: 'relative',
  zIndex: 1,
  ...(!isModal && {
    position: 'sticky',
    padding: '16px 16px 0 16px',
    top: '0'
  })
}))

export default ShopCartHeader
